import { TSpacing } from '@/lib/contentstack-sdk/types';

export const orGenericContentMockData = {
  top_spacing: 'md' as TSpacing,
  bottom_spacing: 'md' as TSpacing,
  rich_text: `<p>This is a sample rich text content for the right column. It can include <strong>bold text</strong>, <em>italic text</em>, and other HTML elements.</p>
<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>`,
};
